import { z } from 'zod'
import { match } from 'ts-pattern'
import { PageType } from '.'
import { SignupFormValues } from './form'
import { staticSignUpConfig } from './config'

export const isPhoneNumberRegex = /^(\+)?([ 0-9]){10,16}$/

export const NO_ACCOUNT_FOUND_ERROR = 'No account found, please contact your administrator.'
export const SIGN_UP_DISABLED =
  'Signup is disabled for this account, please contact your administrator.'

const baseValidationSchema = z.object({
  firstName: z.string().min(1, { message: 'Please enter your first name' }),
  lastName: z.string().min(1, { message: 'Please enter your last name' }),
  email: z.string().email({ message: 'Please enter a valid email' }),
  phone: z.string().regex(isPhoneNumberRegex, { message: 'Please enter a valid phone number' }),
  subscribeNewsletter: z
    .boolean()
    .optional()
    .transform((val) => val?.toString()),
})

const gmValidationSchema = baseValidationSchema.extend({
  companyName: z.string().min(1, { message: 'Please enter your company name' }),
})

const ccValidationSchema = baseValidationSchema.extend({
  companyCode: z.string().min(1, { message: 'Please enter your company code' }),
})

export const validateRules = (formData: Partial<SignupFormValues>, pageType: PageType) => {
  const result = match(pageType)
    .with('gm', () => ({ pageType, ...gmValidationSchema.safeParse(formData) }))
    .with('cc', () => ({ pageType, ...ccValidationSchema.safeParse(formData) }))
    .exhaustive()
  return {
    success: result.success,
    data: result.success ? result.data : null,
    pageType: result.pageType,
    errors: result.success ? {} : result.error.formErrors.fieldErrors,
  }
}

export const createClientMetaData = (
  formData: Partial<SignupFormValues>,
  pageType: PageType,
  forcedDestination?: string,
  accountId?: string,
  locale?: string,
) => {
  const result = validateRules(formData, pageType)
  let urlParams = !result.success || !result.data ? '' : new URLSearchParams(result.data).toString()
  const destination = forcedDestination || staticSignUpConfig[pageType].destination || ''
  if (accountId) urlParams += `&accountId=${accountId}`
  return {
    urlParams,
    destination,
    locale: locale || '',
  }
}
